import { useEffect } from "react";
import { getEnv } from "../utils/genericUtils";

const useLogoutOnTabClose = () => {
    const userID = sessionStorage.getItem("userId") || localStorage.getItem("userId");
    useEffect(() => {
        const handleLogoutOnClose = () => {

            if (userID) {
                const payload = JSON.stringify({ userID });
                const endpoint = `${getEnv()}/v1/azure/logout_tab_close`;
                navigator.sendBeacon(endpoint, payload);
            }
        };

        // events for better reliability
        window.addEventListener("beforeunload", handleLogoutOnClose);
        window.addEventListener("pagehide", handleLogoutOnClose);

        return () => {
            window.removeEventListener("beforeunload", handleLogoutOnClose);
            window.removeEventListener("pagehide", handleLogoutOnClose);
        };
    }, [userID]);
};

export default useLogoutOnTabClose;